/*jshint esversion: 8 */
//{/* use this to comment inside jsx*/}
import './styles/home.css';
import Image from 'react-bootstrap/Image';
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import ab from './pix/mail.png';
import mp from './pix/arrow-right-1.png';
import l4 from './pix/l4.svg';
import off from './pix/video-thumbnail.jpg';
import reach from './util/home/Global-Reach-scaled.jpg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';




{/**logo should be png file, have a transparent background */}

{/* 6031Rufinaalt01.woff2 Lato and rufinaalt01, maybe web-fonts */}

function Home () {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [aboutUsHover, setAboutUsHover] = useState(false);
    const [strategiesHover, setStrategiesHover] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        // Cleanup: make sure class is removed if the component unmounts
        // while the menu is open (e.g. route change).
        return () => {
            if (menuOpen) document.body.classList.remove("menu-open");
        };
    }, [menuOpen]);

    // Simple toggle for the hamburger button — no more manual DOM calls here.
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    // Dedicated close function used by the X button, overlay, and nav items.
    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Add these states for mobile dropdowns (separate from desktop)
    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileStrategiesOpen, setMobileStrategiesOpen] = useState(false);
    // New State for Scroll Effect
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // If user scrolls more than 150px, trigger the fixed state
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
     <div class=''>

    <Navbar id='nav-ham' expanded={expanded} onToggle={() => setExpanded(!expanded)} collapseOnSelect expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'navbar-fixed-reveal' : ''}`} variant="light">
  <Container className="d-flex w-100 align-items-center justify-content-between" style = {{}} id='nav-con-f'>
  <Navbar.Brand href="/"><Image
                src={l4}
                id='nav-img-og'
                alt="shereen Logo"
            /></Navbar.Brand>

{/* Custom Hamburger Button for mobile */}
  <button
  id='burg'
  className={`hamburger-button ${menuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Menu"
>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
</button>

  <Navbar.Collapse id="responsive-navbar-nav" style = {{}}>
    <Nav className="ms-auto align-items-center"  style = {{marginRight: '-10%'}}  >
    <NavDropdown
                    title={
                        <span  onMouseEnter={() => setAboutUsHover(true)}
                        onMouseLeave={() => setAboutUsHover(false)} onClick={(e) => {e.preventDefault(); navigate('/abt')}} className="custom-span">
                            About Us <FontAwesomeIcon icon={faChevronDown}  className="dropdown-arrow ms-2" style = {{fontSize: '18px'}}/>
                        </span>
                    }
                    id="aboutus-dropdown"
                    className="nav-dropdown-custom"
                    show={aboutUsHover}
                >
                    <NavDropdown.Item onClick={() => navigate('/corporate-governance')}>
                        Corporate Governance
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/chairmans-message')}>
                        Chairman's Message
                    </NavDropdown.Item>
                </NavDropdown>

      {/**SECOND NAV HOV */}
    <NavDropdown
    title={
        <span  onMouseEnter={() => setStrategiesHover(true)}
                onMouseLeave={() => setStrategiesHover(false)} className="custom-span">
            Our Strategies <FontAwesomeIcon icon={faChevronDown} style = {{fontSize: '18px'}} className="dropdown-arrow ms-2" />
        </span>
    }

    id="strategies-dropdown"
    className="nav-dropdown-custom"
    show={strategiesHover}
>
    <NavDropdown.Item onClick={() => navigate('/opportunities')}>
        Opportunistic Investing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/lending')}>
        Direct Lending
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/liquidity-solutions')}>
        Fund Liquidity Solutions
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/corporate-finance')}>
        Corporate Financing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/estate')}>
        Real Estate
    </NavDropdown.Item>
</NavDropdown>
      <Nav.Link id="nav-lks" onClick={() => navigate('/team')}  >Our Team</Nav.Link>
      <Nav.Link id="nav-lks" onClick={() => navigate('/careers')}  >Careers</Nav.Link>
      <Nav.Link id="nav-lks" onClick={() => navigate('/contact-us')}  >Contact Us</Nav.Link>

    </Nav>

  </Navbar.Collapse>
  </Container>
</Navbar>

{/* ====================== CUSTOM MOBILE SLIDE MENU ====================== */}
{/* ====================== FULL SCREEN MOBILE SLIDE MENU ====================== */}
<div className={`mobile-menu-fullscreen ${menuOpen ? 'active' : ''}`}>
  <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}></div>
  <div className="mobile-menu-container">
    <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>×</button>

    <div className="mobile-menu-content">
      <Nav className="flex-column mobile-nav-stack">

        {/* About Us with Dropdown */}
<div className="mobile-dropdown-wrapper">
  <div
    className="mobile-menu-item"
    onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
    style={{ justifyContent: 'space-between', alignItems: 'center' }}
  >
    <span
      onClick={(e) => {
        e.stopPropagation();
        navigate('/abt');
        setMenuOpen(false);
      }}
      style={{ flex: 1, cursor: 'pointer' }}
    >
      About Us
    </span>
    <span className={`dropdown-arrow ${mobileAboutOpen ? 'open' : ''}`} style={{ marginLeft:'20px'}}>
      ▼
    </span>
  </div>
  {mobileAboutOpen && (
    <div className="mobile-sub-menu">
      <div className="sub-item" onClick={() => { navigate('/corporate-governance'); setMenuOpen(false); }}>
        Corporate Governance
      </div>
      <div className="sub-item" onClick={() => { navigate('/chairmans-message'); setMenuOpen(false); }}>
        Chairman's Message
      </div>
    </div>
  )}
</div>

        {/* Our Strategies with Dropdown */}
        <div className="mobile-dropdown-wrapper">
          <div
          className="mobile-menu-item"
          onClick={() => setMobileStrategiesOpen(!mobileStrategiesOpen)}
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span style={{ flex: 1, cursor: 'pointer' }}>
            Our Strategies
          </span>
          <span className={`dropdown-arrow ${mobileStrategiesOpen ? 'open' : ''}`}>▼</span>
        </div>
          {mobileStrategiesOpen && (
            <div className="mobile-sub-menu">
              <div className="sub-item" onClick={() => { navigate('/opportunities'); setMenuOpen(false); }}>
                Opportunistic Investing
              </div>
              <div className="sub-item" onClick={() => { navigate('/lending'); setMenuOpen(false); }}>
                Direct Lending
              </div>
              <div className="sub-item" onClick={() => { navigate('/liquidity-solutions'); setMenuOpen(false); }}>
                Fund Liquidity Solutions
              </div>
              <div className="sub-item" onClick={() => { navigate('/corporate-finance'); setMenuOpen(false); }}>
                Corporate Financing
              </div>
              <div className="sub-item" onClick={() => { navigate('/estate'); setMenuOpen(false); }}>
                Real Estate
              </div>
            </div>
          )}
        </div>

        {/* Our Team */}
        <div className="mobile-menu-item" onClick={() => { navigate('/team'); setMenuOpen(false); }}>
          Our Team
        </div>

        {/* Careers */}
        <div className="mobile-menu-item" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
          Careers
        </div>

        {/* Contact Us */}
        <div className="mobile-menu-item no-border" onClick={() => { navigate('/contact-us'); setMenuOpen(false); }}>
          Contact Us
        </div>

      </Nav>
    </div>
  </div>
</div>

      {/**trusted section*/}
       <Container id="partner" fluid style={{ backgroundImage: `linear-gradient(rgba(36, 50, 94, 0.7), rgba(36, 50, 94, 0.7)), url(${off})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat', marginTop: '6%'}}>
          <Col  md = {5} id = 'partner-col' >
              <Row id = 'partner-row' >A Trusted Partner for Alternative Investment Solutions</Row>
              <Row id = 'investment-row' className="justify-content-center" >Shereen Investment, a premier alternative investment manager, provides creative capital solutions that generate consistent risk-adjusted returns over multiple market and economic cycles.</Row>
              <Row id = 'gtk-row' ><Col><a className="explore"  href = '' onClick={(e) => {e.preventDefault(); navigate('/abt')}}>Get to Know Us</a></Col></Row>
          </Col>
          <Col></Col>
       </Container>
       {/**trusted section*/}

      {/**delivering + investment section*/}
      <Container fluid > {/**padding starts from here */}
        {/**arrow svg code */}
        {/**<symbol id="Lineariconsicon-arrow-right" viewBox="0 0 20 20"><title>arrow-right</title><path class="path1" d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z"></path></symbol> */}
        <Row  id='card-f-row' >
          <Row  className="" style = {{marginTop: '6%', marginBottom: '6%'}}>
              <Col  md = {4} id='deliver-col' >Delivering a Multi-Strategy Approach</Col>
              <Col md = {8} id='deliver-col-txt' >We bring institutional expertise to our specialty sectors and business lines that we apply to creating solutions and identifying opportunities throughout the capital structure. Shereen Investment Company LLC is a leading middle east specialty finance company. We specialize in factoring for Early Stage and Mid-Sized companies. Simply put, we purchase invoices from a broad range of businesses with annual sales ranging from $1 million to $800 million. We invest in companies that are in stable or growing industries with strong management, doing business only in the powerful currencies to ensure our investment is safe and withstands any global market fluctuations.</Col>
          </Row>


          {/**second section cads */}

          {/* Strategy Cards Section */}
          {/* ====================== STRATEGY CARDS SECTION ====================== */}

{/* First Row - 3 Cards */}
<Row style={{  marginTop: '20px', marginBottom: '20px'}} className="g-0">

    {/* Card 1 */}
    <Col md={4} xs={12} id='card-colh'>
        <Card className="strategy-card border-0 shadow-sm">
            <Card.Body style={{ padding: '40px 35px'}}>
                <Card.Title id='card-title-f1'>
                    Opportunistic Investing
                </Card.Title>

                <Card.Text id='card-text-f1'>
                    Provides capital solutions (ranging from senior debt to structured equity) to underserved or capital constrained middle-market companies, real estate lending and specialty finance programs.
                </Card.Text>

                <div style={{ marginTop: '50px' }}>
                    <a href="" className="learn-more-link" id='card-lm-f1' onClick={() => navigate('/opportunities')} >
                        <svg style={{ marginRight: '10px', color: '#b7944d' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill="currentColor"/>
                        </svg>
                        Learn More
                    </a>
                </div>
            </Card.Body>
        </Card>
    </Col>

    {/* Card 2 */}
    <Col md={4} xs={12} id='card-colh'>
        <Card className="strategy-card border-0 shadow-sm">
            <Card.Body style={{ padding: '40px 35px' }}>
                <Card.Title style={{
                    fontSize: '24px',
                    lineHeight: '38px',
                    fontWeight: '700',
                    color: '#24325e',
                    marginBottom: '24px'
                }}>
                    Direct Lending
                </Card.Title>

                <Card.Text style={{
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: '400',
                    color: '#222222'
                }}>
                    Provides flexible senior debt capital solutions to lower-middle and middle-market businesses, with a focus on senior secured, unitranche and second-lien opportunities.

                </Card.Text>

                <div style={{ marginTop: '54px' }}>
                    <a href="" onClick={() => navigate('/lending')} className="learn-more-link" style={{
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: '#24325e',
                        fontWeight: '700',
                        fontSize: '20px'
                    }}>
                        <svg style={{ marginRight: '10px', color: '#b7944d' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill="currentColor"/>
                        </svg>
                        Learn More
                    </a>
                </div>
            </Card.Body>
        </Card>
    </Col>

    {/* Card 3 */}
    <Col md={4} xs={12} id='card-colh'>
        <Card className="strategy-card border-0 shadow-sm">
            <Card.Body style={{ padding: '40px 35px' }}>
                <Card.Title style={{
                    fontSize: '24px',
                    lineHeight: '38px',
                    fontWeight: '700',
                    color: '#24325e',
                    marginBottom: '24px'
                }}>
                    Fund Liquidity Solutions
                </Card.Title>

                <Card.Text style={{
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: '400',
                    color: '#222222'
                }}>
                    Bespoke NAV finance solutions to mature PE funds and other pools of capital to support a wide variety of liquidity needs.
                </Card.Text>

                <div style={{ marginTop: '75px' }}>
                    <a href="" onClick={() => navigate('/liquidity-solutions')} className="learn-more-link" style={{
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: '#24325e',
                        fontWeight: '700',
                        fontSize: '20px'
                    }}>
                        <svg style={{ marginRight: '10px', color: '#b7944d' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill="currentColor"/>
                        </svg>
                        Learn More
                    </a>
                </div>
            </Card.Body>
        </Card>
    </Col>
</Row>

{/* Second Row - 2 Cards */}
<Row style={{ marginTop: '10px', marginBottom: '80px' }} className="g-0">

    {/* Card 4 */}
    <Col md={4} xs={12} id='card-colh'>
        <Card className="strategy-card border-0 shadow-sm">
            <Card.Body style={{ padding: '40px 35px' }}>
                <Card.Title style={{
                    fontSize: '24px',
                    lineHeight: '38px',
                    fontWeight: '700',
                    color: '#24325e',
                    marginBottom: '24px'
                }}>
                    Corporate Financing
                </Card.Title>

                <Card.Text style={{
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: '400',
                    color: '#222222'
                }}>
                    Create and invest in flexible, tailored capital solutions (including private credit, equity or hybrid structures) to European middle-market companies across a variety of industries.
                </Card.Text>

                <div style={{ marginTop: '50px' }}>
                    <a href="" onClick={() => navigate('/corporate-finance')} className="learn-more-link" style={{
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: '#24325e',
                        fontWeight: '700',
                        fontSize: '20px'
                    }}>
                        <svg style={{ marginRight: '10px', color: '#b7944d' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill="currentColor"/>
                        </svg>
                        Learn More
                    </a>
                </div>
            </Card.Body>
        </Card>
    </Col>

    {/* Card 5 */}
    <Col md={4} xs={12} id='card-colh'>
        <Card className="strategy-card border-0 shadow-sm">
            <Card.Body style={{ padding: '40px 35px' }}>
                <Card.Title style={{
                    fontSize: '24px',
                    lineHeight: '38px',
                    fontWeight: '700',
                    color: '#24325e',
                    marginBottom: '24px'
                }}>
                    Real Estate
                </Card.Title>

                <Card.Text style={{
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: '400',
                    color: '#222222'
                }}>
                    Beta Overlay & Hedging Solutions
                </Card.Text>

                <Card.Text style={{
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: '400',
                    color: '#222222'
                }}>
                    <ul>
                        <li>Foreign Exchange Hedging</li>
                        <li>Custom Beta Overlay Services</li>
                        <li>Portable Alpha</li>
                    </ul>
                </Card.Text>

                <div style={{ marginTop: '68px' }}>
                    <a href=""  onClick={() => navigate('/estate')} className="learn-more-link" style={{
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: '#24325e',
                        fontWeight: '700',
                        fontSize: '20px'
                    }}>
                        <svg style={{ marginRight: '10px', color: '#b7944d' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill="currentColor"/>
                        </svg>
                        Learn More
                    </a>
                </div>
            </Card.Body>
        </Card>
    </Col>

    {/* Empty Column (for balance) */}
    <Col md={4}></Col>
</Row>

        </Row>
      </Container>
      {/**investing block end */}

      {/**start reach */}
{/* ====================== GLOBAL REACH SECTION ====================== */}
<Container fluid style={{ backgroundImage: `url(${reach})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
    <Row id='globe-row'>
        <Col lg={4} xs={12} className="px-4 px-md-5 py-5 ms-lg-5">

            <div style={{ marginTop: '68px' }}>
                <h2 style={{
                    fontFamily: 'rufinaalt01',
                    fontWeight: '400',
                    fontSize: 'clamp(32px, 6vw, 48px)',
                    lineHeight: '1.15',
                    color: '#ffffff'
                }}>
                    A Global Reach
                </h2>
            </div>

            <div style={{ marginTop: '48px' }}>
                <p style={{
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontSize: 'clamp(18px, 4vw, 20px)',
                    lineHeight: '1.5',
                    color: '#ffffff',
                    maxWidth: '680px'
                }}>
                    Shereen Investment serves sophisticated institutions, family offices and high-net-worth individuals in Middle East, Europe and Asia who seek innovative alternative investment solutions that provide sustainable income and continuity across different market cycles.
                </p>
            </div>

            <div style={{ marginTop: '48px', marginBottom: '68px' }}>
                <a className="explore" href="" onClick={(e) => {e.preventDefault(); navigate('/contact-us')}}>Explore</a>
            </div>

        </Col>
    </Row>
</Container>

      {/**end reach */}
{/* ====================== CALL TO ACTION SECTION ====================== */}
<Container fluid  className="px-0">
    <Row className="" style = {{marginTop: '1%'}}>   {/* g-0 removes default gap */}

        {/* Card 1: Seeking Capital */}
        <Col lg={6} xs={12}>
            <Card
                className="cta-card"
                style={{
                    backgroundColor: '#24325B',
                    borderRadius: '0',
                    border: 'none',
                    height: '100%'
                }}
            >
                <Card.Body className="text-center py-5 px-4 px-md-5">
                    <Image src={ab} style={{ height: '32px' }} alt="mail" />

                    <h2 style={{
                        fontFamily: 'rufinaalt01',
                        fontWeight: '400',
                        fontSize: 'clamp(28px, 5.5vw, 48px)',
                        lineHeight: '1.15',
                        color: '#ffffff',
                        marginTop: '28px'
                    }}>
                        Interested in Seeking Capital
                    </h2>

                    <p style={{
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        lineHeight: '1.45',
                        color: '#ffffff',
                        maxWidth: '580px',
                        margin: '24px auto 0'
                    }}>
                        Contact us to learn how we apply creativity and flexibility to our capital solutions.
                    </p>

                    <div style={{ marginTop: '45px' }}>
                        <a
                            className="box"
                            onClick={(e) => {e.preventDefault(); navigate('/contact-us')}}
                            style={{
                                border: '1px solid #f7f5f0',
                                padding: '18px 24px',
                                display: 'inline-block',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.4s ease'
                            }}
                        >
                            <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                        </a>
                    </div>
                </Card.Body>
            </Card>
        </Col>

        {/* Card 2: Join Our Team */}
        <Col lg={6} xs={12}>
            <Card
                className="cta-card"
                style={{
                    backgroundColor: '#CD1C18',
                    borderRadius: '0',
                    border: 'none',
                    height: '100%'
                }}
            >
                <Card.Body className="text-center py-5 px-4 px-md-5">
                    <Image src={ab} style={{ height: '32px' }} alt="mail" />

                    <h2 style={{
                        fontFamily: 'rufinaalt01',
                        fontWeight: '400',
                        fontSize: 'clamp(28px, 5.5vw, 48px)',
                        lineHeight: '1.15',
                        color: '#ffffff',
                        marginTop: '28px'
                    }}>
                        Join Our Team
                    </h2>

                    <p style={{
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        lineHeight: '1.45',
                        color: '#ffffff',
                        maxWidth: '580px',
                        margin: '24px auto 0'
                    }}>
                        Strong partnerships with customers start with the right colleagues.
                    </p>

                    <div style={{ marginTop: '45px' }}>
                        <a
                            className="box"

                            onClick={(e) => {e.preventDefault(); navigate('/careers')}}
                            style={{
                                border: '1px solid #f7f5f0',
                                padding: '18px 24px',
                                display: 'inline-block',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.4s ease'
                            }}
                        >
                            <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                        </a>
                    </div>
                </Card.Body>
            </Card>
        </Col>

    </Row>
</Container>
            {/**footer section */}
            <Container  fluid style ={{backgroundColor: '#efefef', fontFamily: 'Lato',  paddingBottom: '10px'}}> {/**marginRight: '2%' */}


                    <Row id='ft-txt'> © Copyright 2026 Shereen Investment Company LLC</Row>
                                            <Row id= 'last-rw' className='d-md-none m-0 p-0'>
                    <Col id='priv-pol' xs={12} onClick={() => navigate('/')} >Privacy Policy</Col>
                    <Col id='priv-pol' xs={12} onClick={() => navigate('/')} >Terms of Use</Col>
                    <Col id='priv-pol' xs={12} onClick={() => navigate('/')}>Disclaimers</Col>
                    <Col id='linkd' xs={12} onClick={() => navigate('/')}><FontAwesomeIcon icon={faLinkedin} className="me-2" /></Col>
                          </Row>




            </Container>

            {/*the below div is last div/ function component div*/}
          </div>
    )
}

export default Home;
